import { ApplicationConfig, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { providePrimeNG } from 'primeng/config';
import { AdvokitPreset } from './shared/theme/primeng-preset';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { authInterceptor } from './core/auth/auth.interceptor';
import { loadingInterceptor } from './core/loading/loading.interceptor';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { LanguageService } from '../assets/i18n/language.service';
import { AppConfigService } from './core/config/app-config.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    // @ts-ignore - Required for PrimeNG components until they migrate away from @angular/animations
    ...provideAnimations(),
    provideHttpClient(
      // withFetch(), // Enables Fetch API support for SSR
      withInterceptors([loadingInterceptor, authInterceptor]) // Functional interceptor
    ),
    providePrimeNG({
      theme: {
        preset: AdvokitPreset,
        options: {
          darkModeSelector: false
        }
      },
      ripple: true
    }),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: '.json'
      }),
      lang: 'bg',
      fallbackLang: 'bg'
    }),
    provideAppInitializer(() => {
      const appConfigService = inject(AppConfigService);
      return appConfigService.load();
    }),
    provideAppInitializer(() => {
      const languageService = inject(LanguageService);
      return languageService.init();
    }),
    MessageService,
    ConfirmationService,
    DialogService
  ]
};
